



















import { snakeCase } from 'lodash'
import Vue from 'vue'
import i18n from 'vue-i18n'
import { Component, Prop } from 'vue-property-decorator'

import { BotProperty } from '../../../../../../../../../BotProperties/components/Properties/types'
import findPropertyById from '../../../../../../../logic/Helpers/findPropertyById'
import SetPropertyCondition from '../../../logic/ConditionTypes/SetPropertyConditions/SetPropertyCondition'

@Component({
  data() {
    return {
      snakeCase,
    }
  }
})
export default class SetConditionView extends Vue {
  @Prop() condition!: SetPropertyCondition

  @Prop() i18n!: i18n

  @Prop() properties!: Array<BotProperty>

  get propertyName(): string | null {
    if (this.condition.property_index) {
      const property = findPropertyById(this.properties, this.condition.property_index)

      if (property) {
        return property.name ?? property.type
      }
    }

    return null
  }
}
